import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Import the MSAL factory function
import { MSALInstanceFactory } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// Asynchronous bootstrap function
async function bootstrap() {
  try {
    // Initialize the MSAL instance
    const msalInstance = MSALInstanceFactory();
    console.log('Initializing MSAL instance...');
    await msalInstance.initialize();
    console.log('MSAL instance initialized.');

    // Bootstrap the Angular application
    await platformBrowserDynamic().bootstrapModule(AppModule);
  } catch (err) {
    console.error('Error during bootstrap:', err);
  }
}

// Start the bootstrap process
bootstrap();
